export default __webpack_public_path__ + "static/media/intro_imgAtLoc.ccc0292f.JPG";